/**
 * @fileoverview gRPC-Web generated client stub for billing.private.paymentgateway
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb';
import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb';

import {
  CompleteEnableSCARequest,
  CompleteEnableSCAResponse,
  CreateAdyenGatewayRequest,
  CreateAdyenGatewayResponse,
  CreateAuthorizeDotNetGatewayRequest,
  CreateAuthorizeDotNetGatewayResponse,
  CreateBraintreeGatewayRequest,
  CreateBraintreeGatewayResponse,
  CreateCardConnectRequest,
  CreateCardConnectResponse,
  CreateCheckoutDotComGatewayRequest,
  CreateCheckoutDotComGatewayResponse,
  CreateIxopayGatewayRequest,
  CreateIxopayGatewayResponse,
  CreateNMIGatewayRequest,
  CreateNMIGatewayResponse,
  CreatePaymentCloudRequest,
  CreatePaymentCloudResponse,
  CreateStripeIntentGatewayRequest,
  CreateStripeIntentGatewayResponse,
  DeletePaymentGatewayRequest,
  DeletePaymentGatewayResponse,
  GetGatewayScaDetailsRequest,
  GetGatewayScaDetailsResponse,
  GetSpreedlyTransactionRequest,
  GetSpreedlyTransactionResponse,
  StartEnableSCARequest,
  StartEnableSCAResponse,
  UpdateAdyenGatewayRequest,
  UpdateAdyenGatewayResponse,
  UpdateAuthorizeDotNetGatewayRequest,
  UpdateAuthorizeDotNetGatewayResponse,
  UpdateBraintreeGatewayRequest,
  UpdateBraintreeGatewayResponse,
  UpdateCardConnectRequest,
  UpdateCardConnectResponse,
  UpdateCheckoutDotComGatewayRequest,
  UpdateCheckoutDotComGatewayResponse,
  UpdateIxopayGatewayRequest,
  UpdateIxopayGatewayResponse,
  UpdateNMIGatewayRequest,
  UpdateNMIGatewayResponse,
  UpdatePaymentCloudRequest,
  UpdatePaymentCloudResponse,
  UpdateStripeGatewayRequest,
  UpdateStripeGatewayResponse} from './payment_gateway_pb';

export class PaymentGatewayServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoCreateCheckoutDotComGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateCheckoutDotComGatewayResponse,
    (request: CreateCheckoutDotComGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateCheckoutDotComGatewayResponse.deserializeBinary
  );

  createCheckoutDotComGateway(
    request: CreateCheckoutDotComGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateCheckoutDotComGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateCheckoutDotComGateway',
      request,
      metadata || {},
      this.methodInfoCreateCheckoutDotComGateway,
      callback);
  }

  methodInfoUpdateCheckoutDotComGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateCheckoutDotComGatewayResponse,
    (request: UpdateCheckoutDotComGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateCheckoutDotComGatewayResponse.deserializeBinary
  );

  updateCheckoutDotComGateway(
    request: UpdateCheckoutDotComGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateCheckoutDotComGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateCheckoutDotComGateway',
      request,
      metadata || {},
      this.methodInfoUpdateCheckoutDotComGateway,
      callback);
  }

  methodInfoCreateBraintreeGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateBraintreeGatewayResponse,
    (request: CreateBraintreeGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateBraintreeGatewayResponse.deserializeBinary
  );

  createBraintreeGateway(
    request: CreateBraintreeGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateBraintreeGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateBraintreeGateway',
      request,
      metadata || {},
      this.methodInfoCreateBraintreeGateway,
      callback);
  }

  methodInfoUpdateBraintreeGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateBraintreeGatewayResponse,
    (request: UpdateBraintreeGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateBraintreeGatewayResponse.deserializeBinary
  );

  updateBraintreeGateway(
    request: UpdateBraintreeGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateBraintreeGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateBraintreeGateway',
      request,
      metadata || {},
      this.methodInfoUpdateBraintreeGateway,
      callback);
  }

  methodInfoCreateAdyenGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateAdyenGatewayResponse,
    (request: CreateAdyenGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateAdyenGatewayResponse.deserializeBinary
  );

  createAdyenGateway(
    request: CreateAdyenGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateAdyenGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateAdyenGateway',
      request,
      metadata || {},
      this.methodInfoCreateAdyenGateway,
      callback);
  }

  methodInfoUpdateAdyenGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateAdyenGatewayResponse,
    (request: UpdateAdyenGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateAdyenGatewayResponse.deserializeBinary
  );

  updateAdyenGateway(
    request: UpdateAdyenGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateAdyenGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateAdyenGateway',
      request,
      metadata || {},
      this.methodInfoUpdateAdyenGateway,
      callback);
  }

  methodInfoCreateAuthorizeDotNetGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateAuthorizeDotNetGatewayResponse,
    (request: CreateAuthorizeDotNetGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateAuthorizeDotNetGatewayResponse.deserializeBinary
  );

  createAuthorizeDotNetGateway(
    request: CreateAuthorizeDotNetGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateAuthorizeDotNetGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateAuthorizeDotNetGateway',
      request,
      metadata || {},
      this.methodInfoCreateAuthorizeDotNetGateway,
      callback);
  }

  methodInfoUpdateAuthorizeDotNetGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateAuthorizeDotNetGatewayResponse,
    (request: UpdateAuthorizeDotNetGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateAuthorizeDotNetGatewayResponse.deserializeBinary
  );

  updateAuthorizeDotNetGateway(
    request: UpdateAuthorizeDotNetGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateAuthorizeDotNetGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateAuthorizeDotNetGateway',
      request,
      metadata || {},
      this.methodInfoUpdateAuthorizeDotNetGateway,
      callback);
  }

  methodInfoCreateIxopayGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateIxopayGatewayResponse,
    (request: CreateIxopayGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateIxopayGatewayResponse.deserializeBinary
  );

  createIxopayGateway(
    request: CreateIxopayGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateIxopayGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateIxopayGateway',
      request,
      metadata || {},
      this.methodInfoCreateIxopayGateway,
      callback);
  }

  methodInfoUpdateIxopayGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateIxopayGatewayResponse,
    (request: UpdateIxopayGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateIxopayGatewayResponse.deserializeBinary
  );

  updateIxopayGateway(
    request: UpdateIxopayGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateIxopayGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateIxopayGateway',
      request,
      metadata || {},
      this.methodInfoUpdateIxopayGateway,
      callback);
  }

  methodInfoCreateNMIGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateNMIGatewayResponse,
    (request: CreateNMIGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateNMIGatewayResponse.deserializeBinary
  );

  createNMIGateway(
    request: CreateNMIGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateNMIGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateNMIGateway',
      request,
      metadata || {},
      this.methodInfoCreateNMIGateway,
      callback);
  }

  methodInfoUpdateNMIGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateNMIGatewayResponse,
    (request: UpdateNMIGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateNMIGatewayResponse.deserializeBinary
  );

  updateNMIGateway(
    request: UpdateNMIGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateNMIGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateNMIGateway',
      request,
      metadata || {},
      this.methodInfoUpdateNMIGateway,
      callback);
  }

  methodInfoDeletePaymentGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    DeletePaymentGatewayResponse,
    (request: DeletePaymentGatewayRequest) => {
      return request.serializeBinary();
    },
    DeletePaymentGatewayResponse.deserializeBinary
  );

  deletePaymentGateway(
    request: DeletePaymentGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DeletePaymentGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/DeletePaymentGateway',
      request,
      metadata || {},
      this.methodInfoDeletePaymentGateway,
      callback);
  }

  methodInfoCreateCardConnectGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateCardConnectResponse,
    (request: CreateCardConnectRequest) => {
      return request.serializeBinary();
    },
    CreateCardConnectResponse.deserializeBinary
  );

  createCardConnectGateway(
    request: CreateCardConnectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateCardConnectResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateCardConnectGateway',
      request,
      metadata || {},
      this.methodInfoCreateCardConnectGateway,
      callback);
  }

  methodInfoUpdateCardConnectGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateCardConnectResponse,
    (request: UpdateCardConnectRequest) => {
      return request.serializeBinary();
    },
    UpdateCardConnectResponse.deserializeBinary
  );

  updateCardConnectGateway(
    request: UpdateCardConnectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateCardConnectResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateCardConnectGateway',
      request,
      metadata || {},
      this.methodInfoUpdateCardConnectGateway,
      callback);
  }

  methodInfoCreatePaymentCloudGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreatePaymentCloudResponse,
    (request: CreatePaymentCloudRequest) => {
      return request.serializeBinary();
    },
    CreatePaymentCloudResponse.deserializeBinary
  );

  createPaymentCloudGateway(
    request: CreatePaymentCloudRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreatePaymentCloudResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreatePaymentCloudGateway',
      request,
      metadata || {},
      this.methodInfoCreatePaymentCloudGateway,
      callback);
  }

  methodInfoUpdatePaymentCloudGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdatePaymentCloudResponse,
    (request: UpdatePaymentCloudRequest) => {
      return request.serializeBinary();
    },
    UpdatePaymentCloudResponse.deserializeBinary
  );

  updatePaymentCloudGateway(
    request: UpdatePaymentCloudRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdatePaymentCloudResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdatePaymentCloudGateway',
      request,
      metadata || {},
      this.methodInfoUpdatePaymentCloudGateway,
      callback);
  }

  methodInfoGetSpreedlyTransaction = new grpcWeb.AbstractClientBase.MethodInfo(
    GetSpreedlyTransactionResponse,
    (request: GetSpreedlyTransactionRequest) => {
      return request.serializeBinary();
    },
    GetSpreedlyTransactionResponse.deserializeBinary
  );

  getSpreedlyTransaction(
    request: GetSpreedlyTransactionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetSpreedlyTransactionResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/GetSpreedlyTransaction',
      request,
      metadata || {},
      this.methodInfoGetSpreedlyTransaction,
      callback);
  }

  methodInfoCreateStripeIntentGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateStripeIntentGatewayResponse,
    (request: CreateStripeIntentGatewayRequest) => {
      return request.serializeBinary();
    },
    CreateStripeIntentGatewayResponse.deserializeBinary
  );

  createStripeIntentGateway(
    request: CreateStripeIntentGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateStripeIntentGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CreateStripeIntentGateway',
      request,
      metadata || {},
      this.methodInfoCreateStripeIntentGateway,
      callback);
  }

  methodInfoUpdateStripeGateway = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateStripeGatewayResponse,
    (request: UpdateStripeGatewayRequest) => {
      return request.serializeBinary();
    },
    UpdateStripeGatewayResponse.deserializeBinary
  );

  updateStripeGateway(
    request: UpdateStripeGatewayRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateStripeGatewayResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/UpdateStripeGateway',
      request,
      metadata || {},
      this.methodInfoUpdateStripeGateway,
      callback);
  }

  methodInfoStartEnableSCA = new grpcWeb.AbstractClientBase.MethodInfo(
    StartEnableSCAResponse,
    (request: StartEnableSCARequest) => {
      return request.serializeBinary();
    },
    StartEnableSCAResponse.deserializeBinary
  );

  startEnableSCA(
    request: StartEnableSCARequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StartEnableSCAResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/StartEnableSCA',
      request,
      metadata || {},
      this.methodInfoStartEnableSCA,
      callback);
  }

  methodInfoCompleteEnableSCA = new grpcWeb.AbstractClientBase.MethodInfo(
    CompleteEnableSCAResponse,
    (request: CompleteEnableSCARequest) => {
      return request.serializeBinary();
    },
    CompleteEnableSCAResponse.deserializeBinary
  );

  completeEnableSCA(
    request: CompleteEnableSCARequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CompleteEnableSCAResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/CompleteEnableSCA',
      request,
      metadata || {},
      this.methodInfoCompleteEnableSCA,
      callback);
  }

  methodInfoGetGatewayScaDetails = new grpcWeb.AbstractClientBase.MethodInfo(
    GetGatewayScaDetailsResponse,
    (request: GetGatewayScaDetailsRequest) => {
      return request.serializeBinary();
    },
    GetGatewayScaDetailsResponse.deserializeBinary
  );

  getGatewayScaDetails(
    request: GetGatewayScaDetailsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetGatewayScaDetailsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/billing.private.paymentgateway.PaymentGatewayService/GetGatewayScaDetails',
      request,
      metadata || {},
      this.methodInfoGetGatewayScaDetails,
      callback);
  }

}

